module.exports = __webpack_public_path__ + "static2023-4-17/img/2020_unactive_btn.ac1df32a.png";